export function toFolder(data, mediaType) {
  return {
    id: data.id,
    name: data.name,
    mediaType,
    parentId: null,
    filesCount: null,
    createdAt: null
  };
}